import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { SafePipe } from './pipes/safe.pipe';
import { ContentFormating } from './pipes/ContentFormating';
import { AppTestComponent } from './components/app-test/app-test.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AvatarModule } from '../shared/standalone-packages/ngx-avatar-master/projects/ngx-avatar/src/public_api';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PcxNgSelectComponent } from './components/pcx-ng-select/pcx-ng-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { DialogAlertComponent } from './components/dialog-alert/dialog-confirm/dialog-alert.component';
import { PcxDayPickerComponent } from './components/pcx-day-picker/pcx-day-picker.component';
import { PcxAvatarComponent } from './components/pcx-avatar/pcx-avatar.component';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';
import { TruncateFilenamePipe } from './pipes/truncate-filename.pipe';
import { StringToDatePipe } from './pipes/string-to-date';
import { PcxSnackbarComponent } from './components/pcx-snackbar/pcx-snackbar.component';
import { PcxDateFormatePipe } from './pipes/pcx-date-formate.pipe';
import { FormatPeriodNumberPipe } from './pipes/format-period-number.pipe';
import { TimeDifferPipe } from './pipes/time-differ.pipe';
import { PcxAvatarByFleIdComponent } from './components/pcx-avatar-by-fle-id/pcx-avatar-by-fle-id.component';
import { AppBasicListComponent } from './components/app-basic-list/app-basic-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ObjectToDisplayPipe } from './pipes/object-to-display.pipe';
import { AppTraningVotingComponent } from './components/app-traning-voting/app-traning-voting.component';
import { AppSlaDetailsComponent } from './components/app-sla-details/app-sla-details.component';
import { SlaDaysLeftPipe } from './pipes/sla-days-left.pipe';
import { SlaStatusByExpireDatePipe } from './pipes/sla-status-by-expired-date';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { CustomIsoDatePipe } from './pipes/custom-iso-date.pipe';
import { CaseDetailsHeaderComponent } from './components/case-details-header/case-details-header.component';
import { TranslateSeedDataPipe } from './pipes/translate-seed-data.pipe';
import { TranslateKeyFromValuePipe } from './pipes/transform-key-from-value.pipe';
import { SelectDocumentTypeModalComponent } from './components/select-document-type-modal/select-document-type-modal.component';
import { AppLinkedJarowaCasesComponent } from './components/app-basic-list/linked-jarowa-cases/linked-jarowa-cases.component';
import { AppLinkedIpexUploadCasesComponent } from './components/app-basic-list/linked-ipex-upload-cases/linked-ipex-upload-cases.component';
import { TranslateSLADelayReasonPipe } from './pipes/translate-sladelay-reason.pipe';
import { LanguageKeyToDisplayLanguagePipe } from './pipes/language-key-to-display-language.pipe';
import { TranslateLabelPipe } from './pipes/translate-label.pipe';
import { ValueExistsInVatsPipe } from './pipes/value-exists-in-vats.pipe';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { SharedDirectiveModule } from './directives/shared-directive.module';
import { OrdinalSuffixPipe } from './pipes/ordinal-suffix.pipe';
import { DocProcessingStatusIconPipe } from './pipes/doc-processing-status-icon.pipe';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BasicCkeditorComponent } from './components/basic-ckeditor/basic-ckeditor.component';
import { UpcomingCheckForDatePipe } from './pipes/upcoming-check-for-date.pipe';
import { DialogModule } from './standalone-packages/dialog/dialog.module';
import { SlaTypeImageSourcePipe } from './pipes/sla-type-image-source.pipe';
import { FilterCaseDocumentListPipe } from './pipes/Filter-Case-Document-List.pipe';
import { SendConsultationCallBackRequestComponent } from './components/send-consultation-call-back-request/send-consultation-call-back-request.component';
import { GetServiceProviderCountPipe } from './pipes/get-service-provider-count.pipe';
import { IpexServiceProviderComponent } from './components/ipex-service-provider/ipex-service-provider.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { GetTradeNamePipe } from './pipes/get-trade-name.pipe';
import { AppManagementSummaryComponent } from './components/app-management-summary/app-management-summary.component';
import { SwissCurrencyPipe } from './pipes/swiss-currency.pipe';
import { FuseSharedModule } from './standalone-packages/ecap3/template-atlas';
import { InterceptorModule } from './standalone-packages/ecap3/core';
import { NgxMatIntlTelInputComponent } from './standalone-packages/ngx-mat-intl-tel-input/projects/ngx-mat-intl-tel-input/src/public-api';
import { NgxMatNativeDateModule } from './standalone-packages/angular-material-components-master/projects/datetime-picker/src/lib/core/native-date.module';
import { NgxMatTimepickerModule } from './standalone-packages/angular-material-components-master/projects/datetime-picker/src/lib/timepicker.module';
import { NgxMatDatetimePickerModule } from './standalone-packages/angular-material-components-master/projects/datetime-picker/src/lib/datepicker-module';
import { GoogleMapComponent } from './components/app-google-map/app-google-map.component';
import { CheckSubTotalAndGrossWithParashiftPipe } from './pipes/check-sub-total-and-gross-with-parashift.pipe';
import { AppServiceNotificationComponent } from './components/app-service-notification/app-service-notification.component';
import { NotificationsInfoPipe } from './pipes/notifications-info.pipe';
import { TranslationFormatterPipe } from './pipes/translation-formatter.pipe';
import { MatMenuModule } from '@angular/material/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { AppPcxDayPickerComponent } from './components/app-pcx-day-picker/app-pcx-day-picker.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { AppAdvanceSearchFilterComponent } from './components/app-advance-search-filter/app-advance-search-filter.component';
import { AccordionModule } from 'primeng/accordion';
import { PopoverModule } from 'primeng/popover';
import { ServiceRejectModalComponent } from './components/service-reject-modal/service-reject-modal.component';
import { UserActivityStatusPipe } from './pipes/user-activity-status.pipe';
import { LastActiveLabelPipe } from './pipes/last-active-label.pipe';
import { AppCaseRestoreModalComponent } from './components/app-case-restore-modal/app-case-restore-modal.component';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { AppConnectedRepairCasesComponent } from './components/app-basic-list/connected-repair-cases/connected-repair-cases.component';
import { AuditRepairConnectedCasesComponent } from './components/audit-repair-connected-cases/audit-repair-connected-cases.component';
import { TabsModule } from 'primeng/tabs';
import { FilePreviewModalComponent } from './components/file-preview-modal/file-preview-modal.component';
import { FilePreviewService } from './services/file-preview.service';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { DrawerModule } from 'primeng/drawer';
import { TagModule } from 'primeng/tag';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { AppPrimeDynamicTableComponent } from './components/app-prime-dynamic-table/app-prime-dynamic-table.component';
import { AppPlatformSetPasswordComponent } from './components/app-platform-set-password/app-platform-set-password.component';
import { CreateUrlTreePipe } from './pipes/create-url-tree.pipe';
import { FauxScrollbarDirective } from '../case-details/directives/faux-scrollbar.directive';
import { TooltipModule } from 'primeng/tooltip';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';

// primeNg modules will be listed here
const primeNgModules = [
    FloatLabelModule,
    DatePickerModule,
    ButtonModule,
    CheckboxModule,
    CardModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MessageModule,
    MenuModule,
    DrawerModule,
    SelectModule,
    AccordionModule,
    PopoverModule,
    MultiSelectModule,
    ToastModule,
    RippleModule,
    TabsModule,
    TableModule,
    TimelineModule,
    TagModule,
    PasswordModule,
    DividerModule,
    TooltipModule
];

@NgModule({
    imports: [
        AvatarModule,
        CommonModule,
        FuseSharedModule,
        FlexLayoutModule,
        FormsModule,
        NgSelectModule,
        TranslateModule,
        InterceptorModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatToolbarModule,
        MatSidenavModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatRippleModule,
        MatListModule,
        InfiniteScrollModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatMomentDateModule,
        NgxMatNativeDateModule,
        NgxMatTimepickerModule,
        NgxMatDatetimePickerModule,
        SharedDirectiveModule,
        CKEditorModule,
        NgxMatIntlTelInputComponent,
        DialogModule,
        GoogleMapsModule,
        MatMenuModule,
        GetTradeNamePipe,
        ...primeNgModules,
        FilterCaseDocumentListPipe,
        AppPcxDayPickerComponent,
        GetServiceProviderCountPipe,
        FauxScrollbarDirective,
        TranslateSeedDataPipe,
        SwissCurrencyPipe,
        NoDataFoundComponent
    ],
    declarations: [
        PcxNgSelectComponent,
        DialogConfirmComponent,
        PcxDayPickerComponent,
        AppTestComponent,
        PcxAvatarComponent,
        TruncateTextPipe,
        TruncateFilenamePipe,
        StringToDatePipe,
        DialogAlertComponent,
        ContentFormating,
        SafePipe,
        PcxSnackbarComponent,
        DeleteModalComponent,
        AppCaseRestoreModalComponent,
        PcxDateFormatePipe,
        FormatPeriodNumberPipe,
        TimeDifferPipe,
        PcxAvatarByFleIdComponent,
        AppBasicListComponent,
        ObjectToDisplayPipe,
        AppTraningVotingComponent,
        AppSlaDetailsComponent,
        SlaDaysLeftPipe,
        SlaStatusByExpireDatePipe,
        DocProcessingStatusIconPipe,
        CustomIsoDatePipe,
        CaseDetailsHeaderComponent,
        TranslateKeyFromValuePipe,
        SelectDocumentTypeModalComponent,
        AppLinkedJarowaCasesComponent,
        AppLinkedIpexUploadCasesComponent,
        AppConnectedRepairCasesComponent,
        TranslateSLADelayReasonPipe,
        LanguageKeyToDisplayLanguagePipe,
        TranslateLabelPipe,
        ValueExistsInVatsPipe,
        DateTimePickerComponent,
        OrdinalSuffixPipe,
        BasicCkeditorComponent,
        UpcomingCheckForDatePipe,
        SlaTypeImageSourcePipe,
        SendConsultationCallBackRequestComponent,
        //GetServiceProviderCountPipe,
        IpexServiceProviderComponent,
        //GetTradeNamePipe,
        AppManagementSummaryComponent,
        GoogleMapComponent,
        CheckSubTotalAndGrossWithParashiftPipe,
        AppServiceNotificationComponent,
        NotificationsInfoPipe,
        TranslationFormatterPipe,
        //AppPcxDayPickerComponent,
        AppAdvanceSearchFilterComponent,
        ServiceRejectModalComponent,
        UserActivityStatusPipe,
        LastActiveLabelPipe,
        AuditRepairConnectedCasesComponent,
        AppPrimeDynamicTableComponent,
        FilePreviewModalComponent,
        AppPlatformSetPasswordComponent,
        CreateUrlTreePipe
    ],
    exports: [
        AvatarModule,
        CommonModule,
        FuseSharedModule,
        FlexLayoutModule,
        PcxNgSelectComponent,
        InterceptorModule,
        DialogConfirmComponent,
        PcxDayPickerComponent,
        AppTestComponent,
        PcxAvatarComponent,
        TruncateTextPipe,
        TruncateFilenamePipe,
        StringToDatePipe,
        DialogAlertComponent,
        ContentFormating,
        SafePipe,
        PcxSnackbarComponent,
        DeleteModalComponent,
        FormatPeriodNumberPipe,
        TimeDifferPipe,
        PcxDateFormatePipe,
        PcxAvatarByFleIdComponent,
        AppBasicListComponent,
        AppTraningVotingComponent,
        AppSlaDetailsComponent,
        SlaDaysLeftPipe,
        SlaStatusByExpireDatePipe,
        DocProcessingStatusIconPipe,
        CustomIsoDatePipe,
        CaseDetailsHeaderComponent,
        TranslateSeedDataPipe,
        TranslateKeyFromValuePipe,
        SelectDocumentTypeModalComponent,
        AppLinkedJarowaCasesComponent,
        AppLinkedIpexUploadCasesComponent,
        AppConnectedRepairCasesComponent,
        TranslateSLADelayReasonPipe,
        LanguageKeyToDisplayLanguagePipe,
        TranslateLabelPipe,
        ValueExistsInVatsPipe,
        DateTimePickerComponent,
        SharedDirectiveModule,
        OrdinalSuffixPipe,
        BasicCkeditorComponent,
        UpcomingCheckForDatePipe,
        NgxMatIntlTelInputComponent,
        FilterCaseDocumentListPipe,
        SlaTypeImageSourcePipe,
        GetServiceProviderCountPipe,
        IpexServiceProviderComponent,
        AppManagementSummaryComponent,
        CheckSubTotalAndGrossWithParashiftPipe,
        AppManagementSummaryComponent,
        AppServiceNotificationComponent,
        //AppPcxDayPickerComponent,
        AppAdvanceSearchFilterComponent,
        ServiceRejectModalComponent,
        UserActivityStatusPipe,
        LastActiveLabelPipe,
        AuditRepairConnectedCasesComponent,
        AppPrimeDynamicTableComponent,
        FilePreviewModalComponent,
        AppPlatformSetPasswordComponent,
        ...primeNgModules,
        CreateUrlTreePipe,
        SwissCurrencyPipe
    ],
    providers: [
        {
            provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
            useValue: { autoActiveFirstOption: true }
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        UpcomingCheckForDatePipe,
        MessageService,
        FilePreviewService
    ]
})
export class SharedModule {}
